import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, MaskLines, Eyebrow } from "./motion";

const NOTS = ["Não tinha garantias.", "Não tinha um plano perfeito.", "Nem sabia onde aquele caminho me iria levar."];

export const Story = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="historia" ref={ref} data-testid="story-container" className="relative bg-paper py-24 text-ink sm:py-36">
      <div className="mx-auto grid max-w-[1400px] gap-16 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Eyebrow num="02">A História</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
              <MaskLines lines={["Também comecei", <span className="text-orange-deep">sem garantias.</span>]} />
            </h2>
            <Reveal delay={0.2} className="relative mt-12 aspect-[4/3] overflow-hidden rounded-[28px]">
              <motion.img style={{ y: imgY }} src="/img/rui-119.webp" alt="Rui Guedes no escritório da Soluções Ideais" className="absolute inset-0 h-[116%] w-full -translate-y-[8%] object-cover" />
              <div className="absolute inset-0 bg-navy/40 mix-blend-multiply" />
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 lg:pt-24">
          <Reveal className="text-xl leading-relaxed sm:text-2xl">
            Em <strong className="font-extrabold">1997</strong> troquei uma carreira estável pela incerteza do setor imobiliário.
          </Reveal>
          <ul className="my-12 space-y-0 border-y border-ink/10">
            {NOTS.map((t, i) => (
              <Reveal as="li" key={t} delay={i * 0.1} className="flex items-baseline gap-5 border-b border-ink/10 py-5 last:border-0">
                <span className="font-mono text-xs text-slate-500">0{i + 1}</span>
                <span className="font-display text-xl font-bold sm:text-2xl">{t}</span>
              </Reveal>
            ))}
          </ul>
          <Reveal className="space-y-6 text-base leading-relaxed text-slate-600 sm:text-lg">
            <p className="font-display text-2xl font-extrabold text-ink sm:text-3xl">Tinha apenas a vontade de construir algo maior.</p>
            <p>Essa decisão transformou a minha vida.</p>
            <p>Anos mais tarde criámos a <strong className="text-ink">Soluções Ideais</strong>, uma rede que hoje está presente em todo o país e continua a crescer através de empresários que decidiram acreditar no seu potencial.</p>
          </Reveal>
          <Reveal className="mt-14 rounded-[28px] bg-navy p-8 text-white sm:p-12">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-orange">Porque acredito numa coisa</p>
            <blockquote className="mt-5 font-display text-2xl font-extrabold leading-tight sm:text-3xl" data-testid="story-belief-quote">
              “As pessoas comuns são capazes de construir histórias extraordinárias quando encontram o método certo e o apoio certo.”
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
